
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    IconButton,
    Dialog,
    DialogTitle,
    Slide,
    Button
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import CloseIcon from "@mui/icons-material/Close";

/*

COMPONENT FOR DISPLAYING DIALOG WHEN RECORD SHALL BE DELETED

*/

export const DeleteDialogComponent: React.FC<{
  openDialog: boolean,
  onCloseDialog: () => void,
  onDelete: () => void
}> = ({
  openDialog,
  onCloseDialog,
  onDelete
}) => {

  const styles = ContainerClasses();

  return (

    <Dialog
          open={openDialog}
          onClose={onCloseDialog}
          maxWidth={"lg"}
          TransitionComponent={Slide}
          TransitionProps={{direction: "up"} as any}
    >
       <Box sx={styles.containerRowB}>
       <Box>
       </Box>
        <IconButton
            edge="start"
            color="inherit"
            aria-label="close"
            onClick={onCloseDialog}
        >
           <CloseIcon />
        </IconButton>
      </Box>

       <DialogTitle>
          Permanently delete record?
       </DialogTitle>

        <Button
            variant="contained"
            color="error"
            type="submit"
            fullWidth
            onClick={onDelete}
          >
             Delete
        </Button>
      </Dialog>


  );

};
